interface Props {
  className?: string
  size?: number
}
export function PlusIcon({ className, size = 40 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="currentColor"
      className={className}
    >
      <path d="M17 23V40H23V23H40V17H23V0H17V17H0V23H17Z" fill="currentColor" />
    </svg>
  )
}
